<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="32"
      height="32"
      rx="16"
      fill="#ECE8F5"
    />
    <path
      d="M16.2354 26.6666C15.6908 26.6666 15.2494 26.2251 15.2494 25.6806V24.0807H13.5898C13.0542 24.0807 12.6201 23.6466 12.6201 23.111C12.6201 22.5755 13.0542 22.1413 13.5898 22.1413H15.2494V18.8295C13.5436 18.5858 12.1312 17.8262 11.0123 16.5507C9.89304 15.2752 9.33344 13.7855 9.33344 12.0814C9.33344 10.2034 10.0063 8.60921 11.3521 7.29883C12.6981 5.98844 14.3259 5.33325 16.2354 5.33325C18.1449 5.33325 19.7727 5.98844 21.1187 7.29883C22.4645 8.60921 23.1374 10.2034 23.1374 12.0814C23.1374 13.7855 22.5777 15.2752 21.4585 16.5507C20.3395 17.8262 18.9272 18.5858 17.2214 18.8295V22.1413H18.881C19.4166 22.1413 19.8507 22.5755 19.8507 23.111C19.8507 23.6466 19.4166 24.0807 18.881 24.0807H17.2214V25.6806C17.2214 26.2251 16.7799 26.6666 16.2354 26.6666ZM19.7232 15.549C20.6846 14.6022 21.1654 13.4589 21.1654 12.1192C21.1654 10.7795 20.6839 9.63677 19.7209 8.69099C18.7581 7.74543 17.5956 7.27265 16.2334 7.27265C14.8712 7.27265 13.7093 7.74618 12.7476 8.69325C11.7862 9.64011 11.3054 10.7834 11.3054 12.1231C11.3054 13.4628 11.7869 14.6055 12.7499 15.5513C13.7127 16.4968 14.8752 16.9696 16.2374 16.9696C17.5996 16.9696 18.7615 16.4961 19.7232 15.549Z"
      fill="#312849"
    />
    <path
      d="M13.9048 13.308C13.9048 13.6727 14.2004 13.9683 14.5651 13.9683C14.9297 13.9683 15.2253 13.6727 15.2253 13.308V11.5809C15.2253 11.2163 14.9297 10.9207 14.5651 10.9207C14.2004 10.9207 13.9048 11.2163 13.9048 11.5809V13.308ZM17.1558 13.308C17.1558 13.6727 17.4514 13.9683 17.816 13.9683C18.1807 13.9683 18.4763 13.6727 18.4763 13.308V11.5809C18.4763 11.2163 18.1807 10.9207 17.816 10.9207C17.4514 10.9207 17.1558 11.2163 17.1558 11.5809V13.308Z"
      fill="#312849"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconFemaleSymbol'
}
</script>
